import Badge from '@splunk/react-ui/Badge';
import { variables } from '@splunk/themes';
import styled from 'styled-components';

export default function DashboardBetaBadge() {
    return <StyledBadge backgroundColor={variables.notificationColorInfoWeak} label="Beta" />;
}

const StyledBadge = styled(Badge)`
    margin-inline: ${variables.spacingSmall};
`;
